<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Fiducia</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-book" />
            Fiducia
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0" v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['Notaris'])">
        <CRow>
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.periodBy" 
                    :options="filter.periodOptions"
                    :searchable="false"
                    id="period-table-fiducia"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.periodBy" :options="filter.periodOptions"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodStart" 
                    :min="filter.minPeriodStart"
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="filterDateFiduciaTable"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    :max="filter.maxPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="filterDateFiduciaTable"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.value" 
                    :options="filter.options"
                    :searchable="false"
                    id="filter-table-fiducia"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.value" :options="filter.options" @change="changeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="filter.value == 'documentStatus'" v-model="filter.filterSearch" :options="filter.filterValueDocumentStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-select v-else-if="filter.value == 'contractStatus'" v-model="filter.filterSearch" :options="filter.filterValueContractStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input v-else maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel Fiducia" :disabled="!fiduciaTable.isLoaded" @click="filterFiduciaTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="fiduciaTable.items"
              :fields="fiduciaTable.fields"
              :busy="!fiduciaTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onFiduciaTableSortChanged"
            >
              <template #cell(contractNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(customerName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(assignmentDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(documentStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(newNotes)="row">
                <CBadge v-if="row.value" color="success">NEW</CBadge>
                <span v-else>-</span>
              </template>
              <template #cell(rejectValidation)="row">
                <span v-if="$helper.isEmpty(row.value) || row.value == false">-</span>
                <CBadge v-else color="danger">REJECTED</CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Detail Fiducia" class="btn-icon mr-1 custom-button-action" @click="$router.push({ name: 'Fiducia Detail', params: { fiduciaId: row.item.contractId } })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!fiduciaTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="fiduciaTable.totalRows" :page="fiduciaTable.currentPage" @limit-change="onFiduciaTableLimitChange" @page-change="onFiduciaTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol class="col-12">
        <b-btn variant="warning" class="float-right btn-sm custom-button-white" title="Download kontrak yang tertampil di tabel" style="width:12rem" :disabled="isDownloading || fiduciaTable.items.length <= 0" @click="downloadContracts">
          <b-spinner small v-if="isDownloading" />
          <span v-else>Download Semua Kontrak</span>
        </b-btn>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'FiduciaList',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isDownloading: false,
      filter: {
        value: "contractNo",
        options: [
          { value:"contractNo", text: "No. Kontrak" },
          { value:"customerName", text: "Nama Customer" },
          { value:"officeName", text: "Nama Office" },
          // { value:"contractDate", text: "Tanggal Kontrak" },
          // { value:"assignmentDate", text: "Tanggal Assign" },
          { value:"documentStatus", text: "Status Dokumen" },
          { value:"contractStatus", text: "Status Kontrak" },
        ],
        filterSearch: '',
        filterType: '',
        filterValue: '',
        filterValueDocumentStatusOptions: [
          { value: "Y", text: "Y" },
          { value: "N", text: "N" },
        ],
        filterValueContractStatusOptions: [
          { value: "WFN", text: "WFN" },
          { value: "STN", text: "STN" },
          { value: "WFA", text: "WFA" },
          { value: "RCE", text: "RCE" },
          { value: "MGR", text: "MGR" },
        ],
        periodOptions: [
          { value:"contractDate", text: "Tanggal Kontrak" },
          { value:"assignmentDate", text: "Tanggal Assign" }
        ],
        periodBy: "contractDate",
        periodStart: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        minPeriodStart: '',
        maxPeriodStart: today,
        periodEnd: today,
        minPeriodEnd: '',
        maxPeriodEnd: today
      },
      fiduciaTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Nama Office", sortable: true},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Penugasan", sortable: true},
          {key: "documentStatus", label: "Status Dokumen", sortable: true},
          {key: "contractStatus", label: "Status Kontrak", sortable: true},
          {key: "newNotes", label: "Notes", sortable: true},
          {key: "rejectValidation", label: "Validasi", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {

    changeFilterType() {
      if (this.filter.value == "documentStatus") {
        this.filter.filterSearch = "Y"
      } else if (this.filter.value == "contractStatus") {
        this.filter.filterSearch = "WFN"
      } else{
        this.filter.filterSearch = null
      }
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.filter.minPeriodEnd = this.filter.periodStart
      this.filter.maxPeriodEnd = this.$moment(this.filter.periodStart).add(1, 'years').format('YYYY-MM-DD')
    },
    onContextPeriodEnd() {
      this.filter.maxPeriodStart = this.filter.periodEnd
      this.filter.minPeriodStart = this.$moment(this.filter.periodEnd).subtract(1, 'years').format('YYYY-MM-DD')
    },
    downloadContracts(page = 1) {
      if(isNaN(page)) {
        this.fiduciaTable.currentPage = 1
      }
      else {
        this.fiduciaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/excel/contractFiduciaByte"
      
      let params = this.$helper.getBasePagedQuery(this.fiduciaTable.currentPage - 1, this.fiduciaTable.perPage)
      if(!this.$helper.isEmpty(this.filter.periodBy)) {
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.fiduciaTable.sortBy != null) {
        params['sortBy'] = this.fiduciaTable.sortBy
        params['asc'] = !this.fiduciaTable.sortDesc
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.isDownloading = true
        this.$axios.get(getUrl, {
          // necessary to avoid encoding returned bytes
          params: params, 
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= "Kontrak_Fiducia-" + Date.now() + ".xlsx"
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // update table with server-side processing on change
    onFiduciaTableLimitChange(newPerPage) {
      this.fiduciaTable.perPage = newPerPage
      // only fetch data when roles apply
      this.getFiduciaTableItems()
    },
    onFiduciaTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getFiduciaTableItems(newPage)
    },
    onFiduciaTableSortChanged(ctx) {
      this.fiduciaTable.sortBy = ctx.sortBy
      this.fiduciaTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getFiduciaTableItems(this.fiduciaTable.currentPage)
    },
    filterDateFiduciaTable(){
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getFiduciaTableItems()
    },
    filterFiduciaTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getFiduciaTableItems()
    },
    // get paginated table contents from server-side
    getFiduciaTableItems(page = 1) {
      if(isNaN(page)) {
        this.fiduciaTable.currentPage = 1
      }
      else {
        this.fiduciaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/fiducia/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.fiduciaTable.currentPage - 1, this.fiduciaTable.perPage)
      if(!this.$helper.isEmpty(this.filter.periodBy)) {
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.fiduciaTable.sortBy != null) {
        params['sortBy'] = this.fiduciaTable.sortBy
        params['asc'] = !this.fiduciaTable.sortDesc
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.fiduciaTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            // sessionStorage.setItem("filterFiduciaPage", this.fiduciaTable.currentPage)
            // sessionStorage.setItem("filterFiduciaSize", this.fiduciaTable.perPage)
            sessionStorage.setItem("filterFiduciaPeriodBy", this.filter.periodBy)
            sessionStorage.setItem("filterFiduciaPeriodStart", this.filter.periodStart)
            sessionStorage.setItem("filterFiduciaPeriodEnd", this.filter.periodEnd)
            sessionStorage.setItem("filterFiduciaType", this.filter.filterType)
            sessionStorage.setItem("filterFiduciaValue", this.filter.filterValue)
            // sessionStorage.setItem("filterFiduciaSortBy", this.fiduciaTable.sortBy)
            // sessionStorage.setItem("filterFiduciaAsc", this.fiduciaTable.sortDesc)
            this.fiduciaTable.items = response.data.data.data
            this.fiduciaTable.totalRows = response.data.data.totalElements
            this.fiduciaTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Fiducia Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Fiducia Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Fiducia Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.fiduciaTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaPage"))){
    //   this.fiduciaTable.currentPage = sessionStorage.getItem("filterFiduciaPage")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaSize"))){
    //   this.fiduciaTable.perPage = sessionStorage.getItem("filterFiduciaSize")
    // }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaPeriodBy"))){
      this.filter.periodBy = sessionStorage.getItem("filterFiduciaPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaPeriodStart"))){
      this.filter.periodStart = sessionStorage.getItem("filterFiduciaPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaPeriodEnd"))){
      this.filter.periodEnd = sessionStorage.getItem("filterFiduciaPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaType"))){
      this.filter.filterType = sessionStorage.getItem("filterFiduciaType")
      this.filter.value = sessionStorage.getItem("filterFiduciaType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterFiduciaValue")
      this.filter.filterSearch = sessionStorage.getItem("filterFiduciaValue")
    }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaSortBy"))){
    //   this.fiduciaTable.sortBy = sessionStorage.getItem("filterFiduciaSortBy")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterFiduciaAsc"))){
    //   this.fiduciaTable.sortDesc = (sessionStorage.getItem("filterFiduciaAsc") === 'true' ? true : false)
    // }
    // get table contents on page load
    this.getFiduciaTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
